var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"md-radio",class:{
    'is-disabled': _vm.disabled,
    'is-checked': _vm.isChecked,
    'is-inline': _vm.inline
  },on:{"click":_vm.$_onClick}},[_c('div',{staticClass:"md-radio-icon"},[_c('md-icon',{attrs:{"name":_vm.currentIcon,"size":_vm.size,"svg":_vm.iconSvg}})],1),(_vm.$slots.default || _vm.label)?_c('div',{staticClass:"md-radio-label"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }